import React from "react";

interface ResendSectionProps {
  resendWait: number;
  isResendDisabled: boolean;
  onResend: () => void;
}

export const ResendSection: React.FC<ResendSectionProps> = ({ resendWait, isResendDisabled, onResend }) =>
  resendWait > 0 ? (
    <span className="text-label-lg text-on-surface-variant font-medium font-poppins align-middle">
      Please wait 30 seconds to receive the code.
    </span>
  ) : (
    <>
      <span className="text-label-lg text-on-surface-variant font-medium font-poppins align-middle">
        Didn't receive it?
      </span>
      <button
        type="button"
        className="mfa-resend-link ml-2 align-middle"
        onClick={onResend}
        disabled={isResendDisabled}
      >
        Resend it.
      </button>
    </>
  );
